import React from "react";
import "./CurrentChat.css";
import MessageIcon from "../../../../media/images/MessageIcon.mjs";
import appLib from "../../../../libs/appLib.mjs";
import CurrentChatForm from "./CurrentChatForm.mjs";
import UserAvatar from "../../../../Controls/UserAvatar.mjs";
import ChatMessage from "./ChatMessage.mjs";
import ImIcon from "../../../../media/images/ImIcon.mjs";
import TextLabel from "../../../../Controls/TextLabel.mjs";

const G = window.glob;

const getChatData = (id, all )=> {
	if (typeof all === 'undefined') all = appLib.imByPlayer();
	if ( ! all?.data ) return [];
	return all.data[id] || [];
};

const info = id => {
	if ( ! id ) return <MessageIcon/>;
	if ( id.startsWith("group:")) return groupinfo(id.replace(/^group:/,''));
	const p = (G.getStatus('Players')||[]).find( p => p.id === id );
	if ( ! p) return <MessageIcon/>;
	let info = p.roles ? p.roles.map( role => appLib.nameByRole(role.id)).join(', ') : "";
	if ( info ) info = G.label( p.roles.length > 1 ? 'Roles' : 'Role') + ': ' + info;
	return (
		<div className="CurrentChatInfo">
			<UserAvatar player={p.id} name={ p.name } icon={ p.icon } />
			<div>
				<div>
					{ p.name ?? p.id }
				</div>
				{ info && (
					<div title={info}>
						{ info }
					</div>
				)}
			</div>
		</div>
	);
}

const groupinfo = id => {
	if ( ! id ) return <ImIcon />;
	const gid = id.replace(/^group:/,'');
	const isGlobal = gid === '*';
	const g = appLib.getGroup(gid);
	if ( ! g?.players ) return <MessageIcon/>;
	const qt = (g.players || []).length;
	const info = (qt && ! isGlobal) ? g.players.map( pi => pi.name ).join(', ') : "";
	return (
		<div className="CurrentChatInfo">
			<UserAvatar name={ g.name } icon={ g.icon } group={ true } />
			{ isGlobal ? (
				<div>
					<div>
						{ g.name ?? gid }
					</div>
					{ qt && (
						<div title={info}>
							<TextLabel value={"UserList"}/>: { qt }
						</div>
					)}
				</div>
			) : (
				<div>
					<div>
						<TextLabel value={"users"} lang={"icon"}/> [{qt}]: { g.name ?? gid }
					</div>
					{ qt && (
						<div title={info}>
							<TextLabel value={"UserList"}/>: { info }
						</div>
					)}
				</div>
			) }
		</div>
	);
}

const CurrentChat = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			me: G.getStatus('Player')?.id,
			data: getChatData( props.chat ),
			group: (props.chat||'').startsWith('group:') ? props.chat.replace(/^group:/,'') : false
		};
		this.send = this.send.bind(this)
		this.uid = G.generateUid('CurrentChat')
	}
	componentDidMount() {
		G.register('NewImReceived', all => {
			const newdata = getChatData( this.props.chat, all.data );
			if ( newdata.length !== this.state.data.length ) this.setState({ data: newdata });
		}, this.uid);
	}
	componentWillUnmount() {
		G.deregister(this.uid);
	}

	async send(txt) {
		const o = { body: txt, text: true, from: G.getStatus('Player')?.id };
		if ( this.state.group ) {
			o.group = this.state.group;
		} else {
			o.to = [ this.props.chat ];
		}
		return await appLib.sendIm( o );
	}
	render() {
		setTimeout( ()=>{
			const c = document.getElementById(this.uid).querySelector('.CurrentChatContent');
			if (! c) return;
			const m = c.lastChild;
			if ( m ) m.scrollIntoView(false);
			appLib.setImRead( this.props.chat )
		});
		return(
			<div className={"ChatArea CurrentChat"} id={this.uid}>
				<div className={"box-title"}>
					<span
						className={"closer"}
						onClick={() => {
							this.props.openChat()
						}}
					/>
					{ info( this.props.chat ) }
				</div>
				<div className={"box-wrap"}>
					<div className={"CurrentChatWrap"}>
						<div className={"CurrentChatContent"}>
							{ this.state.data.map( m => (
								<ChatMessage
									key={m.id}
									user={this.state.me}
									message={m}
								/>
							)) }
						</div>
						<CurrentChatForm send={this.send} />
					</div>
				</div>
			</div>
		)
	}
}

export default CurrentChat;